import {
  get,
  put,
  post
} from '../configApi'
export async function getCompany(body) {
  return await get(`/company/list/admin`, body)
}

export async function updateCompany(body) {
  return await put(`/company/manage/update`, body)
}

export async function insertCompany(body) {
  return await post(`/company/manage/insert`, body)
}
export async function getCompanyByID(body) {
  return await get(`/company/detail/admin/byid`, body)
}
export async function activeCompany(body) {
  return await put(`/company/manage/active`, body)
}
export async function updateCompanyAdCom(body) {
  return await put(`/company/manage/updatecompanybyuser`, body)
}

export function getCreditPoint(body) {
  return get(`/company/detail/admin/credit-point/compatible`, body)
}